import React, { useContext, useEffect, useState } from "react";

import Header from "../../components/Header";
import AgendaCalendario from "../../componentsv2/AgendaCalendario";

import { ModalAviso } from "../../componentsv2/ModalAviso";
import { FormularioContext } from "../../componentsv2/AgendaCalendario/Context/FormularioContext";

export default function Respiratorio() {
  // Exames para unidade 42 (HIDROGÊNIO E METANO)
  const examesUnidade42 = ["SIBO – HIDROGÊNIO E METANO", "LACTOSE – HIDROGÊNIO E METANO", "FRUTOSE – HIDROGÊNIO E METANO", "SIBO – HIDROGÊNIO", "LACTOSE – HIDROGÊNIO", "FRUTOSE – HIDROGÊNIO"];
  
  // Exames para unidade 64 (apenas HIDROGÊNIO)
  const examesUnidade64 = ["SIBO – HIDROGÊNIO", "LACTOSE – HIDROGÊNIO", "FRUTOSE – HIDROGÊNIO"];

  const [exames, setExames] = useState(examesUnidade42);

  const [novosHorarios, setNovosHorarios] = useState([
    "06:30",
    "07:00",
    "08:30",
  ]);

  const diasSemana = [1, 2, 3, 4, 5, 6];
  const acesso = "RES";

  const [openModalAlerta, setOpenModalAlerta] = useState(false);

  const { unidade, setUnidade } = useContext(FormularioContext);

  // Função para verificar se deve usar os novos horários (a partir de uma data limite)
  const deveUsarNovosHorarios = () => {
    const hoje = new Date();
    const dataLimite = new Date("2025-08-05T00:00:00");
    return hoje >= dataLimite;
  };

  useEffect(() => {
    setUnidade(42);
    setOpenModalAlerta(true);
  }, []);

  useEffect(() => {
    const usarNovosHorarios = deveUsarNovosHorarios();
    
    if (unidade === 64) {
      // Unidade 64 (Seaway)
      if (usarNovosHorarios) {
        // Novos horários: 06:30 e 07:30
        setNovosHorarios(["06:30", "07:30"]);
      } else {
        // Horários antigos: apenas 07:00
        setNovosHorarios(["07:00"]);
      }
      setExames(examesUnidade64);
    } else {
      // Unidade Major (42)
      if (usarNovosHorarios) {
        // Novos horários: 06:30, 07:00, 08:30
        setNovosHorarios(["06:30", "07:00", "08:30"]);
      } else {
        // Horários antigos: 06:30, 07:00, 08:30 (já são os mesmos)
        setNovosHorarios(["06:30", "07:00", "08:30"]);
      }
      setExames(examesUnidade42);
    }
  }, [unidade]);

  return (
    <>
      <Header titulo="Exame Respiratório" />
      <ModalAviso
        modalText={
          `OBRIGATÓRIO ENVIO DAS RECOMENDAÇÕES/CARDÁPIO PARA REALIZAR O TESTE.\nCrianças de até 6 anos: os agendamentos devem ser realizados exclusivamente na unidade Major.`
        }
        open={openModalAlerta}
        onClose={setOpenModalAlerta}
      />
      <AgendaCalendario
        agenda="respiratorio"
        unidade={unidade}
        exames={exames}
        horarios={novosHorarios}
        diasSemana={diasSemana}
        acesso={acesso}
      />
    </>
  );
}